module.exports = __webpack_public_path__ + "static/media/masungi-loading-logo.1008572c.png";